import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import cx from "classnames";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import isEmpty from "lodash/isEmpty";
import get from 'lodash/get';
import * as actions from "../../actions";
import OrderOnCallButton from "../Button/OrderOnCallButton";
import "./SelectSlot.scss";
import { isFastingRequired } from "../../utils/helper";

class SelectSlot extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSlot: {},
      selectedDate: "",
      flag: false,
    };
  }

  getSampleTypes = () => {
    const { cartData } = this.props;
    const testDetails = get(cartData, 'test_details', []);
    return testDetails
    .flatMap(data => data.sample_type.split(','))
    .map(type => type.trim().toLowerCase())
    .filter((type, index, self) => self.indexOf(type) === index);
  };

  componentDidMount() {
    const {
      selectedCityID,
      selectedSlot,
      dates,
      selectedLab,
      selectedPincode,
      cartData,
      selectedGender,
    } = this.props;

    const sampleTypes = this.getSampleTypes();

    const params = {
      mce_id: selectedLab.mce_id,
      lab_id: selectedLab.item_id,
      address_pincode: selectedPincode,
      patient_quantity: 1,
      requires_prep: isFastingRequired(cartData) ? 1 : 0,
      ben_gender: selectedGender,
      sample_types: sampleTypes,
    };
    this.props.actions
      .getDiagosticsSlotDate(selectedCityID, params)
      .then(() => {
        this.selectDate(selectedSlot.date || dates[0]);
        this.setState({
          selectedSlot: selectedSlot || {},
          selectedDate: selectedSlot.date || dates[0],
        });
      });
  }

  selectSlot = (selectedSlot) => {
    this.setState({ selectedSlot });
  };

  componentDidUpdate() {
    if (
      this.state.flag &&
      this.props.selectedSlot &&
      this.props.selectedSlot.date
    ) {
      this.props.checkValidationOnSameOrder();
      this.setState({
        flag: false,
      });
    }
  }

  doneClick = () => {
    this.props.actions.setDiagosticsSelectedSlot(this.state.selectedSlot);
    this.props.doneClick();
    this.setState({
      flag: true,
    });
  };

  selectDate = (selectedDate) => {
    const { selectedCityID, selectedLab, selectedPincode, cartData, selectedGender } =
      this.props;
    const sampleTypes = this.getSampleTypes();
    const params = {
      mce_id: selectedLab.mce_id,
      lab_id: selectedLab.item_id,
      address_pincode: selectedPincode,
      patient_quantity: 1,
      requires_prep: isFastingRequired(cartData) ? 1 : 0,
      ben_gender: selectedGender,
      sample_types: sampleTypes,
    };
    this.setState({ selectedDate });
    this.props.actions.getDiagosticsSlotTime(
      selectedDate,
      selectedCityID,
      params
    );
  };

  tConvert = (times) => {
    // Check correct time format and split into components
    let time = times
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [times];

    if (time.length > 1) {
      // If time format correct
      time = time.slice(1); // Remove full string match value
      time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
      time.splice(3, 2);
    }
    return time.join(""); // return adjusted time or original string
  };

  render() {
    const {
      loading,
      loadingTime,
      dates,
      time,
      showDoneCTA,
      showSlotRadioBtn,
      appointmentDateText,
      appointmentSlotsText,
    } = this.props;
    const { selectedDate, selectedSlot } = this.state;

    return (
      <div>
        <div className="slotSelectionContainer">
          {!loading && (
            <div className="appointmentDateContainer">
              <div className="dateTimeHeading">{appointmentDateText}</div>
              <ul className="dateCarousel">
                {dates.map((date, index) => (
                  <li
                    className={cx("dateSlot", {
                      selected: selectedDate === date,
                    })}
                    key={index}
                    onClick={() => this.selectDate(date)}
                  >
                    <div className="date">{moment(date).format("MMM DD")}</div>
                    <div className="day">{moment(date).format("ddd")}</div>
                  </li>
                ))}
              </ul>
            </div>
          )}
          {!loadingTime && (
            <div className="appointmentTimeContainer">
              <div className="dateTimeHeading">{appointmentSlotsText}</div>
              <div className="dateTimeSlotSelection">
                {time.length > 0 ? (
                  time.map((t, index) => (
                    <label key={index}>
                      {showSlotRadioBtn && (
                        <input
                          disabled={t.available_capacity < 1}
                          type="radio"
                          name="time"
                          value={1}
                          onClick={() => this.selectSlot(t)}
                        />
                      )}
                      <span
                        className={
                          t.available_capacity < 1 ? "disableText" : ""
                        }
                      >
                        {this.tConvert(t.start_time)} -{" "}
                        {this.tConvert(t.end_time)}
                      </span>
                      {t.available_capacity < 6 && t.available_capacity > 0 && (
                        <span className="slotLeft">
                          Last {t.available_capacity} slots!
                        </span>
                      )}
                      {t.available_capacity < 1 && (
                        <span className="slotLeft">Slot Full</span>
                      )}

                      {t.charge > 0 && (
                        <span className="slotCharge">₹{t.charge}</span>
                      )}
                    </label>
                  ))
                ) : (
                  <div>
                    No Slots available for{" "}
                    {moment(selectedDate).format("MMM DD")}.
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
        {showDoneCTA && (
          <div className="dneContainer">
            <OrderOnCallButton
              text="Done"
              type={1}
              loading={false}
              onClickFunction={this.doneClick}
              disabled={isEmpty(selectedDate) || isEmpty(selectedSlot)}
            />
          </div>
        )}
      </div>
    );
  }
}

SelectSlot.propTypes = {
  actions: PropTypes.object,
  selectedSlot: PropTypes.object,
  loading: PropTypes.bool,
  loadingTime: PropTypes.bool,
  dates: PropTypes.array,
  time: PropTypes.array,
  selectedCityID: PropTypes.number,
  doneClick: PropTypes.func,
  selectedLab: PropTypes.object.isRequired,
  selectedPincode: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  checkValidationOnSameOrder: PropTypes.func.isRequired,
  showDoneCTA: PropTypes.bool,
  showSlotRadioBtn: PropTypes.bool,
  appointmentDateText: PropTypes.string,
  appointmentSlotsText: PropTypes.string,
};

SelectSlot.defaultProps = {
  actions: {},
  loading: true,
  loadingTime: true,
  dates: [],
  time: [],
  selectedSlot: {},
  doneClick: null,
  selectedCityID: "",
  showDoneCTA: true,
  showSlotRadioBtn: true,
  appointmentDateText: "Select Appointment Date",
  appointmentSlotsText: "Select Appointment Time",
};

export default connect(
  (state) => ({
    dates: state.diagnosticsSlots.slotDates,
    time: state.diagnosticsSlots.slotTimes,
    loading: state.diagnosticsSlots.loading,
    loadingTime: state.diagnosticsSlots.loadingTime,
    selectedLab: state.diagnosticsCart.selectedLab,
    selectedSlot: state.diagnosticsSlots.selectedSlot,
    cartData: state.diagnosticsCart.data,
    selectedGender: state.patients.selectedGender,
  }),
  (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
  })
)(SelectSlot);
